import React from 'react';
import { shape, string } from 'prop-types';

import Button from '@material-ui/core/Button';
import { Link, withRouter } from 'react-router-dom';

import classes from './DocsCard.module.css';
import EsmsCard from '../../components/EsmsCard';

const DocsCard = ({ location }) => (
    <EsmsCard
        imagePath="/assets/images/docsIconColor.svg"
        title="Developer Docs"
    >
        <div className={classes.contents}>
            <p>
                The BOB platform provides 3rd party developers (and customers) access to a set of REST API's for interfacing with Key2Act applications. The REST API is currently in limited release
            </p>
            <Button
                color="primary"
                component={Link}
                to={{
                    pathname: '/devportal/docs',
                    search:   location.search
                }}
                variant="contained"
            >
                View API Docs
            </Button>
        </div>
    </EsmsCard>
);


DocsCard.propTypes = {
    location: shape({
        search: string
    }).isRequired
};

export default withRouter(DocsCard);
